var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-chi",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
          "item-group-layout": "title-above",
          "is-title-box-visible": "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "sectionTitleImage",
              fn: function () {
                return [_vm._t("sectionTitleImage")]
              },
              proxy: true,
            },
            {
              key: "beforeBottomContentArea",
              fn: function () {
                return [_vm._t("beforeBottomContentArea")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-chi",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
          "item-group-layout": "title-above",
          "is-title-box-visible": "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "sectionTitleImage",
              fn: function () {
                return [_vm._t("sectionTitleImage")]
              },
              proxy: true,
            },
            {
              key: "beforeBottomContentArea",
              fn: function () {
                return [_vm._t("beforeBottomContentArea")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }